export default {
  headerContent: {
    title: 'Türk Nippon Sigorta Ferdi Kaza Sigortası Fiyatları',
    slogan: "Ferdi Kaza Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'FERDİ KAZA SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Türk Nippon Sigorta Ferdi Kaza Sigortası',
    description: {
      title: 'Türk Nippon Sigorta Ferdi Kaza Sigortası Nedir? ',
      content: [
        'Kazalar her an yaşanmakta ve gündelik yaşamın akışını bozmaktadır. Hayat ne kadar beklenmedik olayla dolu olursa başınıza gelecek risklerin oranı da artmaktadır. Böylesi durumlarda güvence sağlamak, kendinizi ve sevdiklerinizi güvence altına almak için ferdi kaza sigortası yaptırmalısınız.',
        'Türk Nippon Sigorta ferdi kaza sigortası kişiyi ve yakınlarını olası kaza durumlarının yaşanması dâhilinde koruma altına alan ve durumlar neticesinde maddi zorluklar yaşanmaması için tazminat ödeyen sigorta türüdür.'
      ]
    },
    subContent: {
      title: 'Türk Nippon Sigorta Ferdi Kaza Sigortası Neleri Kapsar?',
      content: [
        {
          paragraph:
            'Ferdi kaza sigortasının kapsamı, sigortalı kişilerin ihtiyaçları gözetilerek geniş tutulmuştur. Bu kapsamda ev kazalarından kene ısırmalarına kadar geniş bir yelpazede güvenceler sunulmaktadır. İlgili güvencelerin gerçekleşmesi halinde sigorta ödeme yapmaktadır. ',
          subList: null
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Ferdi Kaza Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Ferdi Kaza Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Ferdi Kaza Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Ferdi Kaza Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Ferdi Kaza Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Türk Nippon  Sigorta Ferdi Kaza Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
